





import React, {useState} from 'react';

import "./MoreInfo.css"
import NavBar from '../../Components/NavBar/NavBar';
import ContactUsForm from '../../Components/ContactUsForm/ContactUsForm';
import Faqs from '../../Components/FAQs/FAQs';
import Footer from '../../Components/Footer/Footer';



function MoreInfo() { 
 

  return <>

      <div className='MoreInfoContainer'>   

            <NavBar/>

              <div className='CoursesWholeforewording'>       

                    <div className='HeadingFilter'>
                            <div className='preword'>
                                    <p>UNILUS Online</p>
                            </div>
                            <div className='FilterDropDown'>
                                    <button>Request More information</button>
                            </div>
                    </div>
                    <div className='MoreWording'> 
                        <div className='moreWordingContainer'>  

                            <h1>Request More information</h1>  

                            {/* <p>
                                    Gain applicable skills, build new business capabilities, and tap into the confidence you need to improve your organization and advance your career.
                            </p> */}

                        </div>
                         

                    </div>

            </div>

            {/* END OF FOREWORD */}

            <ContactUsForm/>
            <Faqs/>
            <Footer/>

      </div>
       
  </>
  
  ;
}

export default MoreInfo;